import { CharAPICall } from 'api/charAPICall';
import { DatCache } from 'api/datCache';
import { GenericAPICall } from 'api/genericAPICall';
import { LogStream, utils_api } from 'generics/common';
import { SettingsInjections } from 'generics/settingsInjections';

LogStream.enable("APICALLDEBUG");

////////////////////////////////////////////
// class UnlockAccessAPICall
class UnlockAccessAPICall extends GenericAPICall {
  normalizeResponse(resp) {
    return resp.result || resp.response;
  }

  getInterfaceUrl() {
    return SettingsInjections.getUsedCircuit().userstat_server;
  }
};

////////////////////////////////////////////
// class FriendsListAPICall
class FriendsListAPICall extends CharAPICall {
  constructor(appid) {
    super("cln_get_contact_lists_ext");
    this.appid = appid;
  }

  getInterfaceUrl() {
    const unlockAccessList = utils_api.getStored(["AchievementApp", "UnlockAccessConfig"]);
    let currentAppConfig = unlockAccessList[this.appid];

    if (currentAppConfig == undefined)
      return false;

    this.appendHeader("groupName", currentAppConfig.groupName);
    this.appendHeader("appid", this.appid);
    return currentAppConfig.url;
  }
};

function getUnlockAccessConfig() {
  let configCall = new UnlockAccessAPICall("GetUnlockAccessConfig");

  return configCall.GET().then((resp) => {
    LogStream("APICALLDEBUG").info(`GetUnlockAccessConfig - got response:`, resp);

    let unlockAccessList = {};

    resp.forEach(({ appId, groupName, url }) => {
      unlockAccessList[appId] = { groupName, url };
    });

    return unlockAccessList;
  });
}

function getAppFriendsList(appId) {
  return UnlockAccessConfigCacheResolver.resolve().then((unlockAccessList) => {
    let groupName = null;
    let groupAppId = null;

    if (unlockAccessList[appId] !== undefined)
      groupName = unlockAccessList[appId]['groupName'];
    else {
      const gamesList = SettingsInjections.getGamesList();
      const currentGame = gamesList?.find((game) => appId == game.appid);
      const appids = currentGame?.appids || [];

      groupAppId = appids.find(id => unlockAccessList[id] !== undefined);

      if (groupAppId != undefined)
        groupName = unlockAccessList[groupAppId]['groupName'] || null;
    }

    if (!groupName)
      return Promise.reject("empty group name");

    let friendsCall = new FriendsListAPICall(groupAppId || appId);

    return friendsCall.POST().then(
      (resp) => {
        console.log('getAppFriendsList -> ', resp);
        return {
          'appId': appId,
          'appFriendsList': resp[groupName] || []
        };
      },
      (error) => {
        console.log('getAppFriendsList failed -> ', error);
        return {
          'appId': appId,
          'appFriendsList': []
        };
      }
    );
  });
}

export function getFriendsList(appids) {
  return Promise.allSettled(
    appids.map(appid => getAppFriendsList(appid))
  ).then((results) => {
    let friendsList = [];

    results.forEach((result, index) => {
      if (result.status === "fulfilled" && result.value?.appFriendsList) {
        result.value.appFriendsList.forEach(({ uid, nick }) => {
          friendsList.push({ appId: appids[index], uid, nick });
        });
      }
    });

    return friendsList;
  });
}

////////////////////////////////////////////
class UnlockAccessConfigCache extends DatCache {
  constructor() {
    super({ name: "unlockAccessConfig", timeoutMin: 60 });
  }

  fetch(_, __) {
    return getUnlockAccessConfig();
  }
}

export const UnlockAccessConfigCacheResolver = new UnlockAccessConfigCache();